import { render, staticRenderFns } from "./AlertGroup.vue?vue&type=template&id=4ff51e06&"
import script from "./AlertGroup.vue?vue&type=script&lang=js&"
export * from "./AlertGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports